import React from 'react';

// Shared white content-block wrapper with an optional icon-led title. Used
// throughout order/checkout/account pages so every "card of information"
// looks identical instead of each page inventing its own container — matches
// the rounded-3xl/border-emerald-50/serif-heading card shell CheckoutPage
// and ProfilePage already hand-roll for the same role.
const SectionCard = ({ title, icon: Icon, children, className = '' }) => (
  <div className={`bg-white rounded-3xl border border-emerald-50 shadow-card p-6 mb-6 ${className}`}>
    {title && (
      <h2 className="serif text-xl text-emerald-950 mb-4 flex items-center gap-2">
        {Icon && <Icon size={18} className="text-emerald-700" aria-hidden="true" />}
        {title}
      </h2>
    )}
    {children}
  </div>
);

export default SectionCard;
